import storage from "store";
import {ACCESS_TOKEN} from '@/store/mutation-types'
const Public = {
    /**
     * 是否已经登录
     * @returns {boolean}
     */
    isLogin(){
        const token = storage.get(ACCESS_TOKEN)
        if(!token){
            return false
        }
        return true
    }

}

export default Public
